import {
  AND_OR_AND,
  CALC_TOTAL_AMOUNT,
  CALC_UNIT_PRICE, CALC_WEIGHT_CONTINUATION,
  COMPARE_AFTER_ACCUMULATE,
  COMPARE_BEFORE_ACCUMULATE,
  ROUNDING_RULES_CEIL,
  ROUNDING_RULES_FLOOR,
  ROUNDING_RULES_ROUND
} from '@/class/cargo/model/parameters/FbaJobConstants'
import * as NumberUtils from '@/utils/NumberUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as FbaJobConstants from '@/class/cargo/model/parameters/FbaJobConstants'
import BigNumber from 'bignumber.js'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { multiply } from '@/utils/commonUtil'
import { formatNumberToThousands } from '@/utils'

export class FbaQuotationUtil {
  // 计算总计费重量
  static calChargeWeight(params) {
    let chargeWeight = 0.0
    const goods = params.goods
    const fbaQuotation = params.fbaQuotation
    const chargingMethod = Number(params.chargingMethod)
    const multipleBoxesCalculationRules = fbaQuotation?.multipleBoxesCalculationRules
    const singleBoxLowestBillableWeight = fbaQuotation?.singleBoxLowestBillableWeight
    const volumetricWeight = Number(params.volumetricWeight)
    const quantity = Number(params.quantity)
    const weight = Number(params.weight)
    const cubage = Number(params.cubage)
    // 有货物明细
    if (goods && goods.length > 0) {
      // 有渠道
      if (fbaQuotation) {
        // 先比较再累加
        if (multipleBoxesCalculationRules === COMPARE_BEFORE_ACCUMULATE.code) {
          for (const item of goods) {
            chargeWeight += Number(item.chargeWeight)
          }
        }
        // 先累加再比较
        if (multipleBoxesCalculationRules === COMPARE_AFTER_ACCUMULATE.code) {
          if (chargingMethod === 0) {
            chargeWeight = Math.max(Math.max(volumetricWeight, weight), singleBoxLowestBillableWeight * quantity)
          } else {
            chargeWeight = Math.max(Math.max(volumetricWeight, cubage), singleBoxLowestBillableWeight * quantity)
          }
        }
      } else {
        // 无渠道
        for (const item of goods) {
          chargeWeight += Number(item.chargeWeight)
        }
      }
    } else {
      // 无货物明细
      // 有渠道
      if (fbaQuotation) {
        if (chargingMethod === 0) {
          chargeWeight = Math.max(Math.max(volumetricWeight, weight), singleBoxLowestBillableWeight * quantity)
        } else {
          chargeWeight = Math.max(Math.max(volumetricWeight, cubage), singleBoxLowestBillableWeight * quantity)
        }
      } else {
        // 无渠道
        if (chargingMethod === 0) {
          chargeWeight = Math.max(Math.max(volumetricWeight, weight), 1)
        } else {
          chargeWeight = Math.max(Math.max(volumetricWeight, cubage), 1)
        }
      }
    }
    return chargeWeight
  }

  // 计算单货箱计费重量
  static calSingleChargeWeight(params) {
    let chargeWeight = 0.0
    const goods = params.goods
    const fbaChannel = params.fbaChannel
    const chargingMethod = Number(params.chargingMethod)
    const fbaQuotation = params.fbaQuotation
    const warehouseCode = params.warehouseCode
    const volumetricWeight = Number(params.volumetricWeight)
    const cubage = NumberUtils.roundHalfUp((Number(goods.boxLength) * Number(goods.boxWidth) * Number(goods.boxHeight) / 1000000), 3)
    // 有服务渠道，根据渠道的结算进位规则进行（向上取整，向下取整，四舍五入）
    if (fbaChannel) {
      let setupSettingList = null
      const settlementWeightRoundingRules = fbaQuotation.settlementWeightRoundingRules
      const singleBoxLowestBillableWeight = fbaQuotation.singleBoxLowestBillableWeight
      if (fbaQuotation) {
        setupSettingList = this.getFqByWarehouseCode(fbaQuotation, warehouseCode)
      }
      // 计费方式：KG   单箱材积 和 单箱重量 比大小 取大值根据进位规则取值  和单箱最低计费重量比大小 取大值
      // 计费方式：CBM  单箱材积 和 单箱长*款*高/100w 比大小取大值 取大值根据进位规则取值
      if (chargingMethod === 0) {
        const value = Math.max(volumetricWeight, goods.singleBoxWeight)
        const result = this.calBySettlementWeightRoundingRules({
          value: value,
          setupSettingList: setupSettingList,
          settlementWeightRoundingRules: settlementWeightRoundingRules
        })
        chargeWeight = Math.max(result, singleBoxLowestBillableWeight)
      } else {
        const value = Math.max(volumetricWeight, cubage)
        chargeWeight = this.calBySettlementWeightRoundingRules({
          value: value,
          setupSettingList: setupSettingList,
          settlementWeightRoundingRules: settlementWeightRoundingRules
        })
      }
    } else {
      // 计费方式：KG   单箱材积 和 单箱重量 比大小 取大值
      // 计费方式：CBM  单箱材积 和 单箱长*款*高/100w 取大值
      if (chargingMethod === 0) {
        chargeWeight = Math.max(volumetricWeight, goods.singleBoxWeight)
      } else {
        chargeWeight = Math.max(volumetricWeight, cubage)
      }
    }
    return chargeWeight
  }

  // 根据目的地获取阶梯设置
  static getFqByWarehouseCode(fbaQuotation, warehouseCode) {
    const partitionSettingList = fbaQuotation.partitionSettingList
    let warehouseCodeList = []
    for (const item of partitionSettingList) {
      const pod = item.pod
      if (pod && pod.split(',').length > 0) {
        warehouseCodeList = warehouseCodeList.concat(pod.split(','))
      }
    }
    return warehouseCodeList.indexOf(warehouseCode) > -1 ? fbaQuotation.setupSettingList : null
  }

  // 根据渠道结算重量进位规则计算
  static calBySettlementWeightRoundingRules(params) {
    let result = 0.0
    let value = params.value
    const setupSettingList = params.setupSettingList
    const settlementWeightRoundingRules = params.settlementWeightRoundingRules
    if (setupSettingList && setupSettingList.length > 0) {
      setupSettingList.sort((a, b) => a.minWeight - b.minWeight)
      const calcMethod = Number(setupSettingList[0].calcMethod)
      // 计算方式为单价或总金额
      if (calcMethod === CALC_UNIT_PRICE.code || calcMethod === CALC_TOTAL_AMOUNT.code) {
        const setupSetting = this.matchSetupSetting(setupSettingList, value)
        if (!setupSetting.match) {
          if (setupSetting.max) {
            value = setupSetting.maxWeight
          } else {
            value = setupSetting.minWeight
          }
        }
        result = this.calWeightByCalcAccuracy(value, setupSetting.calcAccuracy, settlementWeightRoundingRules)
      } else {
        // 计算方式为首重/续重
        const setupSetting = setupSettingList[0]
        let followWeight = null
        let followValue = null
        if (value > setupSetting.maxWeight) {
          followValue = value - setupSetting.maxWeight
          const continuationSetupSettingList = setupSettingList.filter(e => Number(e.calcMethod) === CALC_WEIGHT_CONTINUATION.code)
          followWeight = this.matchSetupSetting(continuationSetupSettingList, followValue)
        }
        if (value < setupSetting.minWeight) {
          result = this.calWeightByCalcAccuracy(setupSetting.minWeight, setupSetting.calcAccuracy, settlementWeightRoundingRules)
        } else if (value >= setupSetting.minWeight && value <= setupSetting.maxWeight) {
          result = this.calWeightByCalcAccuracy(value, setupSetting.calcAccuracy, settlementWeightRoundingRules)
        } else if (followWeight) {
          const firstResult = this.calWeightByCalcAccuracy(setupSetting.maxWeight, setupSetting.calcAccuracy, settlementWeightRoundingRules)
          if (!followWeight.match) {
            if (followWeight.max) {
              followValue = followWeight.maxWeight
            } else {
              followValue = followWeight.minWeight
            }
          }
          const followResult = this.calWeightByCalcAccuracy(followValue, followWeight.calcAccuracy, settlementWeightRoundingRules)
          result = firstResult + followResult
        }
      }
    }
    return result
  }

  // 匹配梯度
  static matchSetupSetting(setupSettingList, value) {
    const weightInterval = []
    let setupSetting = null
    for (const item of setupSettingList) {
      weightInterval.push(Number(item.minWeight))
      weightInterval.push(Number(item.maxWeight))
    }
    weightInterval.push(value)
    weightInterval.sort((a, b) => a - b)
    const index = weightInterval.indexOf(value)
    const match = (index % 2) !== 0
    let max = false
    // 匹配到阶梯
    if (match) {
      for (const item of setupSettingList) {
        if (Number(item.minWeight) === weightInterval[index - 1] && Number(item.maxWeight) === weightInterval[index + 1]) {
          setupSetting = item
          break
        }
      }
    } else {
      // 没匹配到则取当前值后的阶梯
      if (index === 0) {
        setupSetting = setupSettingList[0]
      } else if (index === weightInterval.length - 1) {
        setupSetting = setupSettingList[setupSettingList.length - 1]
        max = true
      } else {
        for (const item of setupSettingList) {
          if (Number(item.minWeight) === weightInterval[index + 1]) {
            setupSetting = item
            break
          }
        }
      }
    }
    if (setupSetting) {
      setupSetting.match = match
      setupSetting.max = max
    }
    return setupSetting
  }

  // 根据计算精度计算重量
  static calWeightByCalcAccuracy(value, calcAccuracy, rules) {
    let result = 0.0
    switch (rules) {
      case ROUNDING_RULES_CEIL.code:
        result = this.calWeightRoundUp(value, calcAccuracy)
        break
      case ROUNDING_RULES_FLOOR.code:
        result = this.calWeightRoundDown(value, calcAccuracy)
        break
      case ROUNDING_RULES_ROUND.code:
        result = this.calWeightRound(value, calcAccuracy)
        break
    }
    return result
  }

  // 计算重量向上取整
  static calWeightRoundUp(value, calcAccuracy) {
    let result = 0.0
    // 取模
    const mod = parseInt(value / calcAccuracy + '')
    const ifInt = value % calcAccuracy === 0
    result = ifInt ? calcAccuracy * mod : calcAccuracy * (mod + 1)
    return result
  }

  // 计算重量向下取整
  static calWeightRoundDown(value, calcAccuracy) {
    let result = 0.0
    // 取模
    const mod = parseInt(value / calcAccuracy + '')
    result = calcAccuracy * mod
    return result
  }

  // 计算重量四舍五入
  static calWeightRound(value, calcAccuracy) {
    let result = 0.0
    let decPart = ''
    if (Number(value).toString().indexOf('.') > -1) {
      decPart = Number(value).toString().split('.')[1]
    }
    let mod = parseInt(value / calcAccuracy + '')
    const ifInt = value % calcAccuracy === 0
    let decLength = 0
    if (Number(calcAccuracy).toString().indexOf('.') > -1) {
      decLength = Number(calcAccuracy).toString().split('.')[1].length
    }
    if (decLength === 1) {
      if (decPart.toString().substring(0, 1) > 4) {
        if (!ifInt) {
          mod++
        }
      }
    } else if (decLength === 2) {
      if (decPart.toString().substring(1) > 4) {
        if (!ifInt) {
          mod++
        }
      }
    }
    result = calcAccuracy * mod
    return result
  }

  // 获取FBA费用信息
  static getFbaChargeInfo(params) {
    const fbaQuotation = params.fbaQuotation
    if (fbaQuotation) {
      const td = this.getTdInfo(params)
      if (td && td.length > 0) {
        td.sort((a, b) => a.minWeight - b.minWeight)
        params.td = td
        const calcMethod = Number(td[0].calcMethod)
        // 计算方式为单价或总金额
        if (calcMethod === CALC_UNIT_PRICE.code) {
          return this.getUnitPriceChargeInfo(params)
        } else if (calcMethod === CALC_TOTAL_AMOUNT.code) {
          return this.getTotalAmountChargeInfo(params)
        } else {
          return this.getWeightChargeInfo(params)
        }
      }
    }
  }

  // 获取FBA附加费信息
  static getFbaAdditionalChargeInfo(params) {
    const chargeList = params.fbaQuotation.chargeList
    if (chargeList && chargeList.length > 0) {
      for (const item of chargeList) {
        // 费用名称
        const chargeItemId = item.chargeItemId
        // 币种
        const currency = item.currency
        // 数量
        const quantity = 1
        // 单价
        let unitRate = 0.0
        // 含税价
        let amount = unitRate
        // 不含税价
        let excludingTaxAmount = unitRate
        // 单位
        const measure = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'chineseName', '票', 'code')
        const chargeSceneList = item.chargeSceneList
        if (chargeSceneList && chargeSceneList.length > 0) {
          params.chargeSceneList = chargeSceneList
          // 匹配加收场景
          const chargeScene = this.matchChargeScene(params)
          // 计算附加费
          if (chargeScene) {
            const calcMethodStr = '附加费'
            let estimatedAmountStr = ''
            if (Number(chargeScene.calcMethod) === 0) {
              unitRate = chargeScene.fixedExpenses
              estimatedAmountStr = chargeScene.fixedExpenses + ''
            } else if (Number(chargeScene.calcMethod) === 1) {
              params.chargeScene = chargeScene
              const chargeInfo = this.calcByFormula(params)
              unitRate = chargeInfo.result
              estimatedAmountStr = chargeInfo.estimatedAmountStr
            }
            amount = unitRate
            excludingTaxAmount = unitRate
            return {
              chargeItemId: chargeItemId,
              currency: currency,
              quantity: quantity,
              unitRate: unitRate,
              amount: amount,
              excludingTaxAmount: excludingTaxAmount,
              measure: measure,
              calcMethodStr: calcMethodStr,
              estimatedAmountStr: estimatedAmountStr
            }
          }
        }
      }
    }
  }

  // 通过计算公式计算
  static calcByFormula(params) {
    let result = 0.0
    const chargeScene = params.chargeScene
    const fieldDic = {
      'ZWX': 'quantity',
      'ZZL': 'weight',
      'ZTJ': 'cubage',
      'JFZL': 'chargeWeight',
      'CJ': 'volumetricWeight'
    }
    let estimatedAmountStr = ''
    if (chargeScene.mode2 > 0 && chargeScene.mode3 > 0) {
      const param1 = params[fieldDic[chargeScene.param1]] || chargeScene.param1
      const param2 = params[fieldDic[chargeScene.param2]] || chargeScene.param2
      const param3 = params[fieldDic[chargeScene.param3]] || chargeScene.param3
      const mode2Str = ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_FbaJobConstants$CALC_MODES, 'code', chargeScene.mode2, 'chineseName')
      const mode3Str = ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_FbaJobConstants$CALC_MODES, 'code', chargeScene.mode3, 'chineseName')
      estimatedAmountStr = param1 + mode2Str + param2 + mode3Str + param3
      result = this.calcCharge(this.calcCharge(param1, chargeScene.mode2, param2), chargeScene.mode3, param3)
    } else if (chargeScene.mode2 > 0) {
      const param1 = params[fieldDic[chargeScene.param1]] || chargeScene.param1
      const param2 = params[fieldDic[chargeScene.param2]] || chargeScene.param2
      const mode2Str = ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_FbaJobConstants$CALC_MODES, 'code', chargeScene.mode2, 'chineseName')
      estimatedAmountStr = param1 + mode2Str + param2
      result = this.calcCharge(param1, chargeScene.mode2, param2)
    } else if (chargeScene.mode3 > 0) {
      const param2 = params[fieldDic[chargeScene.param2]] || chargeScene.param2
      const param3 = params[fieldDic[chargeScene.param3]] || chargeScene.param3
      const mode3Str = ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_FbaJobConstants$CALC_MODES, 'code', chargeScene.mode3, 'chineseName')
      estimatedAmountStr = param2 + mode3Str + param3
      result = this.calcCharge(param2, chargeScene.mode3, param3)
    }
    return { result: result, estimatedAmountStr: estimatedAmountStr }
  }

  // 通过公式计算费用
  static calcCharge(value1, formula, value2) {
    value1 = Number(value1)
    value2 = Number(value2)
    let result = 0
    switch (formula) {
      case 1:
        result = value1 + value2
        break
      case 2:
        result = value1 - value2
        break
      case 3:
        result = value1 * value2
        break
      case 4:
        result = NumberUtils.ToFixed2(value1 / value2, 2)
        break
      case 5:
        result = value1 > value2 ? value1 : value2
        break
      case 6:
        result = value1 < value2 ? value1 : value2
        break
    }
    return result
  }

  // 匹配加收场景
  static matchChargeScene(params) {
    const chargeSceneList = params.chargeSceneList
    let chargeScene = null
    for (const item of chargeSceneList) {
      params.chargeScene = item
      const compare1 = this.checkChargeCondition(params, 1)
      const compare2 = this.checkChargeCondition(params, 2)
      const compare3 = this.checkChargeCondition(params, 3)
      let valid = false
      if (item.relationShip2 > 0 && item.relationShip3 > 0) {
        if (item.relationShip2 === AND_OR_AND.code) {
          valid = compare1 && compare2
        } else {
          if (item.relationShip3 === AND_OR_AND.code) {
            valid = compare1 || compare2 && compare3
          } else {
            valid = compare1 || compare2 || compare3
          }
        }
        if (item.relationShip3 === AND_OR_AND.code) {
          valid = valid && compare3
        } else {
          valid = valid || compare3
        }
      } else if (item.relationShip2 > 0) {
        if (item.relationShip2 === AND_OR_AND.code) {
          valid = compare1 && compare2
        } else {
          valid = compare1 || compare2
        }
      } else if (item.relationShip3 > 0) {
        if (item.relationShip3 === AND_OR_AND.code) {
          valid = compare2 && compare3
        } else {
          valid = compare2 || compare3
        }
      } else {
        valid = compare1
      }
      if (valid) {
        chargeScene = item
        break
      }
    }
    return chargeScene
  }

  // 校验加收条件
  static checkChargeCondition(params, label) {
    const fieldDic = {
      'ZWX': 'quantity',
      'ZZL': 'weight',
      'ZTJ': 'cubage',
      'JFZL': 'chargeWeight',
      'CJ': 'volumetricWeight'
    }
    let valid = false
    const chargeScene = params.chargeScene
    let type = ''
    let rule = ''
    let value = ''
    switch (label) {
      case 1:
        if (chargeScene.type1) {
          type = params[fieldDic[chargeScene.type1]]
          rule = chargeScene.rule1
          value = chargeScene.value1
        }
        break
      case 2:
        if (chargeScene.type2) {
          type = params[fieldDic[chargeScene.type2]]
          rule = chargeScene.rule2
          value = chargeScene.value2
        }
        break
      case 3:
        if (chargeScene.type3) {
          type = params[fieldDic[chargeScene.type3]]
          rule = chargeScene.rule3
          value = chargeScene.value3
        }
        break
    }
    if (type && typeof rule === 'number' && typeof value === 'number') {
      switch (rule) {
        case 1:
          valid = type < value
          break
        case 2:
          valid = type <= value
          break
        case 3:
          valid = type > value
          break
        case 4:
          valid = type >= value
          break
        case 5:
          valid = type === value
          break
        case 6:
          valid = type !== value
          break
      }
    }
    return valid
  }

  // 获取计算方式为单价的费用信息
  static getUnitPriceChargeInfo(params) {
    const fbaQuotation = params.fbaQuotation
    const shippingType = fbaQuotation.shippingType
    const chargeWeight = params.chargeWeight
    const amountInfo = this.getAmount(params)
    const price = amountInfo.amount
    // 费用信息
    let chargeItemName = ''
    switch (shippingType) {
      case 'SE':
        chargeItemName = '海运费'
        break
      case 'AE':
        chargeItemName = '空运费'
        break
      case 'RE':
        chargeItemName = '运费'
        break
    }
    const chargeItemId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'zhName', chargeItemName, 'itemId')
    const currency = fbaQuotation.currency
    const quantity = chargeWeight
    const unitRate = price
    const amount = price * chargeWeight
    const excludingTaxAmount = price * chargeWeight
    const measure = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'chineseName', '计费重量价', 'code')
    return {
      chargeItemId: chargeItemId,
      currency: currency,
      quantity: quantity,
      unitRate: unitRate,
      amount: amount,
      excludingTaxAmount: excludingTaxAmount,
      measure: measure,
      calcMethodStr: '单价',
      estimatedAmountStr: amountInfo.estimatedAmountStr
    }
  }

  // 获取计算方式为总金额的费用信息
  static getTotalAmountChargeInfo(params) {
    const fbaQuotation = params.fbaQuotation
    const shippingType = fbaQuotation.shippingType
    const amountInfo = this.getAmount(params)
    const price = amountInfo.amount
    // 费用信息
    let chargeItemName = ''
    switch (shippingType) {
      case 'SE':
        chargeItemName = '海运费'
        break
      case 'AE':
        chargeItemName = '空运费'
        break
      case 'RE':
        chargeItemName = '运费'
        break
    }
    const chargeItemId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'zhName', chargeItemName, 'itemId')
    const currency = fbaQuotation.currency
    const quantity = 1
    const unitRate = price
    const amount = unitRate
    const excludingTaxAmount = unitRate
    const measure = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'chineseName', '票', 'code')
    return {
      chargeItemId: chargeItemId,
      currency: currency,
      quantity: quantity,
      unitRate: unitRate,
      amount: amount,
      excludingTaxAmount: excludingTaxAmount,
      measure: measure,
      calcMethodStr: '总金额',
      estimatedAmountStr: amountInfo.estimatedAmountStr
    }
  }

  // 获取计算方式为首重/续重的费用信息
  static getWeightChargeInfo(params) {
    const fbaQuotation = params.fbaQuotation
    const shippingType = fbaQuotation.shippingType
    const amountInfo = this.getAmount(params)
    const price = amountInfo.amount
    // 费用信息
    let chargeItemName = ''
    switch (shippingType) {
      case 'SE':
        chargeItemName = '海运费'
        break
      case 'AE':
        chargeItemName = '空运费'
        break
      case 'RE':
        chargeItemName = '运费'
        break
    }
    const chargeItemId = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'zhName', chargeItemName, 'itemId')
    const currency = fbaQuotation.currency
    const quantity = 1
    const unitRate = price
    const amount = unitRate
    const excludingTaxAmount = unitRate
    const measure = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'chineseName', '票', 'code')
    return {
      chargeItemId: chargeItemId,
      currency: currency,
      quantity: quantity,
      unitRate: unitRate,
      amount: amount,
      excludingTaxAmount: excludingTaxAmount,
      measure: measure,
      calcMethodStr: '首重/续重',
      estimatedAmountStr: amountInfo.estimatedAmountStr
    }
  }

  // 获取阶梯信息
  static getTdInfo(params) {
    const fbaQuotation = params.fbaQuotation
    const warehouseCode = params.warehouseCode
    const authorizationValue = params.authorizationValue
    for (const item of fbaQuotation.customerPriceList) {
      if (Number(item.quotationObject) === Number(authorizationValue)) {
        for (const fq of item.fqRowData) {
          const pod = fq.pod
          if (pod && pod.split(',').length > 0) {
            const warehouseCodeList = pod.split(',')
            if (warehouseCodeList.indexOf(warehouseCode) > -1) {
              return fq.tdRowData
            }
          }
        }
      }
    }
    return null
  }

  // 获取金额
  static getAmount(params) {
    let estimatedAmountStr = ''
    let amount = 0.0
    const chargeWeight = params.chargeWeight
    const td = params.td
    if (td && td.length > 0) {
      const calcMethod = Number(td[0].calcMethod)
      // 计算方式为单价或总金额
      if (calcMethod === CALC_UNIT_PRICE.code || calcMethod === CALC_TOTAL_AMOUNT.code) {
        const setupSetting = this.matchSetupSetting(td, chargeWeight)
        amount = setupSetting.amount
        estimatedAmountStr = amount + '*' + (calcMethod === CALC_UNIT_PRICE.code ? chargeWeight : '1')
      } else {
        // 计算方式为首重/续重
        const setupSetting = td[0]
        let followWeight = null
        let followValue = null
        if (chargeWeight > setupSetting.maxWeight) {
          followValue = chargeWeight - setupSetting.maxWeight
          const continuationTd = td.filter(e => e.calcMethod === CALC_WEIGHT_CONTINUATION.code)
          followWeight = this.matchSetupSetting(continuationTd, followValue)
        }
        if (chargeWeight < setupSetting.minWeight) {
          amount = setupSetting.minWeight * setupSetting.amount
          estimatedAmountStr = setupSetting.minWeight + '*' + setupSetting.amount
        } else if (chargeWeight >= setupSetting.minWeight && chargeWeight <= setupSetting.maxWeight) {
          amount = chargeWeight * setupSetting.amount
          estimatedAmountStr = chargeWeight + '*' + setupSetting.amount
        } else if (followWeight) {
          const firstResult = setupSetting.maxWeight * setupSetting.amount
          estimatedAmountStr = setupSetting.maxWeight + '*' + setupSetting.amount
          let followResult = 0.0
          if (!followWeight.match) {
            if (followWeight.max) {
              followResult = followWeight.maxWeight * followWeight.amount
              estimatedAmountStr = estimatedAmountStr + '+' + followWeight.maxWeight + '*' + followWeight.amount
            } else {
              followResult = followWeight.minWeight * followWeight.amount
              estimatedAmountStr = estimatedAmountStr + '+' + followWeight.minWeight + '*' + followWeight.amount
            }
          } else {
            followResult = followValue * followWeight.amount
            estimatedAmountStr = estimatedAmountStr + '+' + followValue + '*' + followWeight.amount
          }
          amount = firstResult + followResult
        }
      }
    }
    return { amount: amount, estimatedAmountStr: estimatedAmountStr }
  }

  static conversionRMBLabel(charge) {
    if (charge) {
      const amount = new BigNumber(charge.amount)
      const exchangeRate = new BigNumber(charge.exchangeRate)
      // CARGO-26500，系统利用外币作为本位币进行结算
      // const num = amount.multipliedBy(exchangeRate)
      // const num = NumberUtils.ToFixed2(multiply(amount, exchangeRate), 2)
      const num = NumberUtils.ToFixed2(RateUtil.getAmountByCurrency(multiply(amount, exchangeRate), charge.localCurrency), 2)
      charge.localAmount = num
      return formatNumberToThousands(NumberUtils.formatNumber(num, 2, true), 2).toString()
    }
    return '0.00'
  }
}
